import MemHourly from './mem-hourly.vue'
export default MemHourly
